/**
 * Loads Google Tag Manager when VITE_GTM_ID is set (production).
 * GA4 measurement (G-X5DNDBM4XP) is configured inside GTM, not via vue-gtag-next.
 */
export function initGoogleTagManager() {
    if (typeof window === "undefined" || typeof document === "undefined") {
        return;
    }

    window.dataLayer = window.dataLayer || [];

    const gtmId = (import.meta.env.VITE_GTM_ID || "").trim();
    if (!gtmId || gtmId === "GTM-XXXXXXX") {
        if (import.meta.env.DEV) {
            console.info("[analytics] VITE_GTM_ID not set — GTM snippet skipped (dataLayer events still queue).");
        }
        return;
    }

    if (
        document.querySelector(`script[data-gtm-id="${gtmId}"]`) ||
        document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`)
    ) {
        return;
    }

    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    script.setAttribute("data-gtm-id", gtmId);
    document.head.appendChild(script);

    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
}
